import React from 'react'

import Header from '../../Component/Header/Header'
import Routers from '../../router/Router'
import Footer from '../../Component/Footer/Footer'

const Layout = () => {
  return (
    <>
    <Header />
    <Routers />
    <Footer />
    </>
  )
}

export default Layout